var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcActiveTest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_275_375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 12.2168V13.5718C8.33035 13.8573 8.2539 14.1372 8.11148 14.3847C7.96906 14.6322 7.76545 14.839 7.52016 14.9851C6.99945 15.3708 6.57586 15.8726 6.28307 16.4507C5.99027 17.0288 5.83634 17.6671 5.8335 18.3151",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 12.2168V13.5718C11.6697 13.8573 11.7461 14.1372 11.8885 14.3847C12.0309 14.6322 12.2346 14.839 12.4798 14.9851C13.0006 15.3708 13.4241 15.8726 13.7169 16.4507C14.0097 17.0288 14.1637 17.6671 14.1665 18.3151",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 7.49967H16.25C16.8025 7.49967 17.3324 7.28018 17.7231 6.88948C18.1138 6.49878 18.3333 5.96888 18.3333 5.41634C18.3333 4.86381 18.1138 4.3339 17.7231 3.9432C17.3324 3.5525 16.8025 3.33301 16.25 3.33301H15",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 18.333H16.6668",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7.50033C5 8.82641 5.52678 10.0982 6.46447 11.0359C7.40215 11.9735 8.67392 12.5003 10 12.5003C11.3261 12.5003 12.5979 11.9735 13.5355 11.0359C14.4732 10.0982 15 8.82641 15 7.50033V2.50033C15 2.27931 14.9122 2.06735 14.7559 1.91107C14.5996 1.75479 14.3877 1.66699 14.1667 1.66699H5.83333C5.61232 1.66699 5.40036 1.75479 5.24408 1.91107C5.0878 2.06735 5 2.27931 5 2.50033V7.50033Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99984 7.49967H3.74984C3.1973 7.49967 2.6674 7.28018 2.2767 6.88948C1.886 6.49878 1.6665 5.96888 1.6665 5.41634C1.6665 4.86381 1.886 4.3339 2.2767 3.9432C2.6674 3.5525 3.1973 3.33301 3.74984 3.33301H4.99984",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_275_375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActiveTest);
export default __webpack_public_path__ + "static/media/ic_active_test.f4db0fdd4af50968e1ae41966b6acd42.svg";
export { ForwardRef as ReactComponent };